import { ApiProperty } from "@nestjs/swagger";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { Assets } from "../../open-assets/open-assets-entity";
import { AssetTransferMethodEnum, TransferStatusEnum } from "@gtpl/shared-models/common-models";

@Entity('asset_transfer')
export class AssetTransfer {
    
    @PrimaryGeneratedColumn('increment', {
        name: 'asset_transfer_id'
    })
    assetTransferId: number;

    @Column({
        type: 'enum',
        enum: TransferStatusEnum,
        nullable: true,
        default: TransferStatusEnum.IN_TRANSIT,
        name: 'status'
    })
    status: TransferStatusEnum;
    @Column("int", {
        nullable: false,
        name: "unit_id",
    })
    unitId: number;

    @Column({
        nullable: false,
        name: "transfer_date"
    })
    transferredDate: Date;

    @Column({
        nullable: true,
        name: "received_date"
    })
    receivedDate: Date;

    @Column({
        type: 'enum',
        enum: AssetTransferMethodEnum,
        nullable: false,
        name: 'transfer_type',
        default: AssetTransferMethodEnum["Plant To Plant"]
    })
    transferType: string;

    @Column("varchar", {
        nullable: true,
        name: "dc_number",
        length: 50
    })
    dcNumber: string;

    @Column("varchar", {
        nullable: true,
        name: "mrn_number",
        length: 50
    })
    mrnNumber: string;
    
    @Column('int', {
        name:'from_plant'
    })
    fromPlant: number;

    @Column('int', {
        name:'to_plant'
    })
    toPlant: number;

    @Column('int', {
        nullable: true,
        name:'asset_location_id',
        default:0
    })
    assetLocationId : number;

    @Column('int', {
        nullable: true,
        name:'transfered_by',
        default:0
    })
    transferedBy : number;

    @Column('int', {
        nullable: true,
        name:'received_by',
        default:0
    })
    receivedBy : number;

    @Column('int',{
        name: 'asset_id'
    })
    assetsId : number;

    @Column('int',{
        nullable: true,
        name: 'indent_id',
        default:0
    })
    indentId : number;

    @Column('int',{
        name: 'asset_category_id'
    })
    assetCategoryId : number;
    
    @Column('int', {
        name:'transfered_quantity'
    })
    transferedQuantity: number;

    @Column('int', {
        nullable: true,
        default:0,
        name:'received_quantity'
    })
    receivedQuantity: number;
    @Column("varchar", {
        nullable: true,
        length: 60,
        name: "note"
    })
    note: string;

    @Column('boolean', {
        name:'is_active',
        default: true,
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        name: "created_user",
        length: 50
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
    
}